import {sanitizeChapters} from '@components/LiveEvent/RecordingsPlayer/@utils/sanitizeChapters';
import {ILiveEventRecording} from '@services/live-events/live-events.model';
import {parseChapterMarks} from '@utils/parseChapterMarks';
import {useMemo} from 'react';

export const useChapterCues = (
    chapterMarks: ILiveEventRecording['chapter_marks'],
    duration: number | null | undefined,
    mismatchThreshold = 1.5,
) => {
    return useMemo(() => {
        if (!chapterMarks?.length || !duration) {
            return {cues: [], isChapterDurationMismatch: false};
        }

        const parsed = parseChapterMarks(chapterMarks);
        const cues = sanitizeChapters(parsed, duration);

        const lastCueEnd = cues.at(-1)?.endTime ?? 0;
        const isChapterDurationMismatch =
            Math.abs(duration - lastCueEnd) > mismatchThreshold;

        return {cues, isChapterDurationMismatch};
    }, [chapterMarks, duration]);
};
